import { render, staticRenderFns } from "./promotionadd.vue?vue&type=template&id=0abaaa12&"
import script from "./promotionadd.vue?vue&type=script&lang=js&"
export * from "./promotionadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports